module.exports = __webpack_public_path__ + "201811/img/member_level_0.2cb09ea7.png";